var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.app},[_c('RouterView'),_c('FlashContainer',{ref:"marketing",attrs:{"name":"marketing","duration":100000000}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }